var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaimedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Claimed_Icon",
    "data-name": "Claimed Icon",
    transform: "translate(-1342 -688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base",
    transform: "translate(1342 688)",
    fill: "#49B776",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-checkmark-circle-outline",
    "data-name": "Icon ionic-md-checkmark-circle-outline",
    d: "M8.685,10.665l-1.26,1.26,4.05,4.05,9-9-1.26-1.26-7.74,7.695Zm10.89,1.71a7.169,7.169,0,1,1-5.22-6.93l1.395-1.4a8.372,8.372,0,0,0-3.375-.675,9,9,0,1,0,9,9Z",
    transform: "translate(1341.625 687.625)",
    fill: "#BB3240"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimedIcon);
export default __webpack_public_path__ + "static/media/claimedIcon.4deeab65dfeda3b79e8bea29806b03db.svg";
export { ForwardRef as ReactComponent };